// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "main.72dbd21e.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"107":"e1be9899","618":"6a70f4a4"}[chunkId] + ".chunk.css";
};